import reuleaux from '../elements/reuleaux.js';
reuleaux.register();
